import React from 'react';
import './home.css';
import VideoPresentation from '../Home/video_presentation.mp4';
import VideoPresentationPoster from '../Home/video_presentation_poster.png';
import Confiance from '../../components/Confiance/Confiance';
import Personnage from '../../components/Personnage/Personnage';
import Avis from '../../components/Avis/Avis';
import SEO from '../../Hook/Seo';
import BreadcrumbsSchema from '../../Hook/BreadcrumbsSchema';

const Home = () => {
  return (
    <>
      <SEO
        title="AM Services – Informatique, Téléphonie IP & Cybersécurité dans les Vosges"
        description="Maintenance & infogérance, téléphonie IP/VoIP, fibre pro, Wi-Fi, cybersécurité (EDR, sauvegardes), alarmes & vidéoprotection."
        path="/"
        keywords={["informatique Vosges", "infogérance", "téléphonie IP", "cybersécurité", "Remiremont", "Épinal"]}
      />
      <BreadcrumbsSchema />

      {/* SECTION HERO */}
      <div className="home-hero-container">
        <div className="video-hero-wrapper">
          <video
            src={VideoPresentation}
            poster={VideoPresentationPoster}
            autoPlay
            muted
            loop
            playsInline
            preload='auto'
            className="hero-background-video"
            title="Présentation vidéo des services - AM Services"
          />
          <div className="hero-overlay"></div>
        </div>

        {/* CONTENEUR GLOBAL ÉPURÉ ET ULTRA VISUEL */}
        <main className="hero-main-showcase">
          <div className="hero-header-text">
            <h1 className="hero-title">AM SERVICES</h1>
            <p className="hero-lead">
              Partenaire de confiance des <span className="highlight-text">entreprises</span> & <span className="highlight-text">administrations vosgiennes</span>.
            </p>
          </div>

          {/* LES 3 PILIERS EN GLASSMORPHISM */}
          <div className="services-grid-showcase">
            <div className="service-pillar-card">
              <div className="pillar-icon-wrapper">
                <span className="pillar-icon">💻</span>
              </div>
              <h3>Informatique</h3>
              <p>Maintenance, infogérance sur-mesure et gestion complète de vos parcs systèmes.</p>
            </div>

            <div className="service-pillar-card active-pillar">
              <div className="pillar-icon-wrapper">
                <span className="pillar-icon">📞</span>
              </div>
              <h3>Télécom</h3>
              <p>Solutions de téléphonie IP/VoIP performantes et déploiement de fibre pro.</p>
            </div>

            <div className="service-pillar-card">
              <div className="pillar-icon-wrapper">
                <span className="pillar-icon">🛡️</span>
              </div>
              <h3>Cybersécurité</h3>
              <p>Protection avancée EDR, sauvegardes externalisées et audits de sécurité.</p>
            </div>
          </div>

          {/* BOUTONS D'ACTION PARFAITEMENT INTÉGRÉS */}
          <div className="hero-cta-group" onClick={() => document.getElementById('expertises').scrollIntoView({ behavior: 'smooth' })}>
            <span className="btn-glass btn-primary-glass">
              Découvrir l'équipe
            </span>

          </div>
        </main>

        {/* INDICATEUR DE SCROLL */}
        <div className="scroll-indicator" onClick={() => document.getElementById('expertises').scrollIntoView({ behavior: 'smooth' })}>
          <span className="arrow"></span>
        </div>
      </div>

      {/* LE RESTE DE LA PAGE */}
      <div className="content-wrapper-global" id="expertises">
        <section className="team-presentation-section" aria-labelledby="equipe-title">
          <div className="team-text-container">
            <h2 id="equipe-title" className="section-title">Notre équipe de spécialistes</h2>
            <div className="accent-bar"></div>
            <p className="team-lead-text">
              8 professionnels, cumulant plus de 15 ans d’expérience, alliant expertise technique et commerciale pour vos projets informatiques et réseaux.
            </p>
          </div>
        </section>

        <Personnage />
        <Confiance />
        <Avis />
      </div>
    </>
  );
};

export default Home;